import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../css_files/Master/AddBoilerSeriesMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";
import Select from "react-select";

function AddBoilerSeriesMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  boilerseriesupdatedata,
}) {
  const [boilerSeriesData, setBoilerSeriesData] = useState({
    Head: triggerupdate ? boilerseriesupdatedata?.head : "",
    SeriesCode: triggerupdate ? boilerseriesupdatedata?.seriesCode : "",
    Description: triggerupdate ? boilerseriesupdatedata?.description : "",
  });

  const [boilerData, setBoilerData] = useState([]);
  const [reloadDropdown, setreloadDropdown] = useState(false);
  const [rotatedropdownicon, setrotatedropdownicon] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState(false);
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/UpdateBoilerSeries`;
      axiosInstance
        .post(URL, {
          ...boilerSeriesData,
          Id: boilerseriesupdatedata.id,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(error);
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries`;
      axiosInstance
        .post(URL, boilerSeriesData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(error);
          setloading(false);
        });
    }
  }

  useEffect(() => {
    setrotatedropdownicon(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Boiler/GetBoilerDropdown`)
      .then((res) => {
        setBoilerData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setrotatedropdownicon(false);
      });
  }, [reloadDropdown]);

  return (
    <form className="add-boiler-series-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Boiler Head{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <Select
            isSearchable
            options={boilerData}
            onChange={(values) => {
              if (values) {
                const val = values?.value;
                setBoilerSeriesData({
                  ...boilerSeriesData,
                  Head: val,
                });
                axiosInstance
                  .get(
                    `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/CheckExistingBoilerSeries?head=${val}&seriesCode=${boilerSeriesData.SeriesCode}`
                  )
                  .then((res) => setMessage(res.data))
                  .catch(console.log);
              }
            }}
            value={boilerData?.find((x) => x?.value === boilerSeriesData.Head)}
            placeholder="Select Boiler Head"
            isClearable
            required
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            menuPlacement="top"
          />

          <i
            class={`fa-solid fa-rotate-right ${
              rotatedropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() => setreloadDropdown(!reloadDropdown)}
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>
          Series Code{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Series Code"
          onChange={(e) =>
            setBoilerSeriesData({
              ...boilerSeriesData,
              SeriesCode: e.target.value,
            })
          }
          value={boilerSeriesData.SeriesCode}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 50);
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/CheckExistingBoilerSeries?head=${boilerSeriesData.Head}&seriesCode=${e.target.value}`
              )
              .then((res) => setMessage(res.data))
              .catch(console.log);
          }}
          required
        />
        <span style={{ color: "red" }}>
          {message &&
            "Boiler Series With this SeriesCode and Head Already Exists"}
        </span>
      </blockquote>
      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Description (Maximum 400 characters)"
          onChange={(e) =>
            setBoilerSeriesData({
              ...boilerSeriesData,
              Description: e.target.value,
            })
          }
          value={boilerSeriesData.Description}
          onInput={(e) => (e.target.value = e.target.value.slice(0, 400))}
        ></textarea>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddBoilerSeriesMaster;
